import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LANGUAGES } from 'src/app/constants';
import { AppGroup } from 'src/app/modules/shared/models/section-config.model';

@Component({
    selector: 'app-group-configuration',
    templateUrl: './app-group-configuration.component.html',
    styleUrls: ['./app-group-configuration.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppGroupConfigurationComponent {
  @Input() appGroup: AppGroup;
  @Input() parentFormGroup: FormGroup;
  languages = LANGUAGES;
  currentLang = "en";

  getNameControl(lang: string){
    return (<any>this.parentFormGroup.controls.names).controls[lang];
  }
}
